import { Trans } from '@lingui/macro'
import classNames from 'classnames'
import * as React from 'react'

import styles from './Totals.module.scss'
import Price from '../../presentation/Price'
import { QuoteDataShippingEstimateInterface } from '../../types'

const getShippingEstimate = (
    shippingEstimate: QuoteDataShippingEstimateInterface,
): React.ReactNode => {
    const { min, max } = shippingEstimate
    const freeShipping = min === 0 && max === 0

    const minimumShippingAmount = <Price price={min} className={styles.price} />

    let value = (
        <Trans id="cart.cartTotals.estimateShippingLabel">
            From {minimumShippingAmount}
        </Trans>
    )

    if (freeShipping) {
        value = (
            // eslint-disable-next-line react/no-unknown-property
            <div className={classNames(styles.price, styles.freeOrDiscount)}>
                <Trans id="cart.cartTotals.freeShippingLabel">Free</Trans>
            </div>
        )
    }

    return value
}

export default getShippingEstimate
